import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/exo-2/400.css";
import "@fontsource/exo-2/700.css";
import { AppManager } from "@kiddocare-platform/portal-common/contexts";
import { LoaderManager, VideocallManagement } from "@kiddocare-platform/portal-common/ui";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import loaderPrimary from "./assets/loader-parent.json";
import { ConfigHelper } from "./helpers/config.helper";

console.log(`
  ██╗  ██╗ ██╗ ██████╗  ██████╗   █████   ██████╗ █████╗   ██████╗  ███████╗
  ██║ ██╔╝ ██║ ██╔══██╗ ██╔══██╗ ██╔══██╗ ██╔═══╝ ██╔══██╗ ██╔══██╗ ██╔════╝
  █████╔╝  ██║ ██║  ██║ ██║  ██║ ██║  ██║ ██║     ███████║ ██████╔╝ █████╗  
  ██╔═██╗  ██║ ██║  ██║ ██║  ██║ ██║  ██║ ██║     ██╔══██║ ██╔══██╗ ██╔══╝  
  ██║  ██╗ ██║ ██████╔╝ ██████╔╝ ╚█████╔╝ ╚█████╗ ██║  ██║ ██║  ██║ ███████╗
  ╚═╝  ╚═╝ ╚═╝ ╚═════╝  ╚═════╝   ╚════╝   ╚════╝ ╚═╝  ╚═╝ ╚═╝  ╚═╝ ╚══════╝
  © ai-health 2025
`);

AppManager.Setup({
  portal: 'parent',
  portalVersion: ConfigHelper.GetAppVersion(),
  urlCommunicationNotificationService: import.meta.env.VITE_API_COMMUNICATION_URL,
  urlPlatformRegistryService: import.meta.env.VITE_API_PLATFORM_URL,
  authConfig: ConfigHelper.GetAuthConfig(),
  firebaseConfig: ConfigHelper.GetFirebaseConfig()
});
VideocallManagement.Setup(ConfigHelper.GetAgoraAppId());
LoaderManager.Setup(loaderPrimary);
console.log("Inizializzazione completata");

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);